import styled from 'styled-components'

import { _S_Normal, _XS_Medium, mainColors, medias } from '@avantstay/backoffice-core'

export const Container = styled.div<{ shouldDisplayFiltersOnSameLine?: boolean }>`
  display: flex;
  flex-direction: ${({ shouldDisplayFiltersOnSameLine }) =>
    shouldDisplayFiltersOnSameLine ? 'row' : 'column'};
  gap: 6px;
  margin-bottom: 10px;

  ${medias.LG_SCREEN`
    > * {
      width: 200px;
    }
  `};

  input {
    ${_S_Normal};
    text-align: right;

    &::placeholder {
      color: ${mainColors.neutralExtraDark} !important;
    }
  }
`

export const InputType = styled.div`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
  margin-right: 10px;
`

export const FilterLabel = styled.p`
  ${_XS_Medium};
  margin-bottom: 6px;
`

export const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  cursor: pointer;
  user-select: none;
`

export const CheckboxInput = styled.input`
  cursor: pointer;
  width: 16px;
  height: 16px;
`

export const CheckboxLabel = styled.span`
  ${_XS_Medium};
  color: ${mainColors.neutralExtremelyDark};
`
